import { IAM_SERVICE } from "../utils/constants";
import { getAccessToken } from "../utils/getAlefuser";
import { getSelectedOrganization } from "../utils/selectedOrganization";
import { userResponse } from "./getUsers";

type userResp = {
  cclUserId?: number | null;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  uuid: string
};

const getUsersByUUIDs = async (ids: string[]): Promise<userResponse[]> => {
  try {
    const params = new URLSearchParams({
      "ids": ids.join(",")
    });
    const URI = `${IAM_SERVICE}/api/users?${params.toString()}`;
    const req = await fetch(URI, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Content-Type": "application/json",
        "X-Tenantid": getSelectedOrganization()
      }
    });
    if (req.status !== 200) {
      throw new Error("request Error");
    }
    const data: userResp[] = (await req.json()) as userResp[];
    return data.map((user) => ({
      id: user.cclUserId || null,
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      uuid: user.uuid
    }) as userResponse);
  } catch (e) {
    console.error(e);
    return [];
  }
};

export default getUsersByUUIDs;
